<template>
  <div id="applicant-edit-tab-internal-history">
    <div class="applicant-show-form">
      <HistroyPage
        is-history
        type="APPLICANT"
        :resource-id="$route.params.id"
      />
    </div>
  </div>
</template>

<script>
import HistroyPage from "./actions/History.vue";

export default {
  components: {
    HistroyPage
  }
};
</script>
